module.exports = __webpack_public_path__ + "static/media/joshua-stannard.8a26aabc.jpg";